const debug = require('debug');

const blazeLogger = debug(process.env.BLAZE_LOGGER_PREFIX || 'blaze');

const defaultNamespaces = {
  log: 'info',
  info: 'info',
  error: 'error',
  warn: 'warn',
  debug: 'debug',
  app: 'app',
  server: 'server'
};

function getLogger(rootNamespace = null, options = {}) {
  const isBrowser = typeof window !== 'undefined';

  if (isBrowser) {
    localStorage.debug = process.env.DEBUG;
  }

  const { customNamespaces = {} } = options;

  const logger = rootNamespace ? blazeLogger.extend(rootNamespace) : blazeLogger;
  const namespaces = { ...defaultNamespaces, ...customNamespaces };

  const presetNamespaceFunctions = {};
  Object.keys(namespaces).forEach(namespace => {
    presetNamespaceFunctions[namespace] = logger.extend(defaultNamespaces[namespace]);
  });

  return {
    ...presetNamespaceFunctions,
    namespaces,
    custom: namespace => logger.extend(namespace)
  };
}

module.exports = getLogger;
